const route = [
    [34.71062215889, 135.36308703334],
    [34.71061191878, 135.36310628502],
    [34.71059888591, 135.36313912613],
    [34.7105886458, 135.36317536459],
    [34.71057654385, 135.36321500041],
    [34.71056630373, 135.36325463622],
    [34.71055606361, 135.36329200714],
    [34.71054396165, 135.36333390786],
    [34.71053279061, 135.36337127877],
    [34.71052255049, 135.36340185497],
    [34.71050672485, 135.3634460206],
    [34.7104908992, 135.36348792132],
    [34.71047041894, 135.3635354843],
    [34.71045086961, 135.36358304728],
    [34.71043132026, 135.36362608045],
    [34.71041363276, 135.36366005401],
    [34.71039222156, 135.36370535209],
    [34.71037081036, 135.36374725281],
    [34.71034939916, 135.36379368334],
    [34.71033078071, 135.3638321867],
    [34.71031588595, 135.36386389536],
    [34.7102972675, 135.36390806098],
    [34.71027632174, 135.36396128622],
    [34.71025933239, 135.36400630119],
    [34.71024257577, 135.36405074992],
    [34.710234197, 135.36407538132],
    [34.71022605142, 135.36409972904],
    [34.71021813857, 135.36412379364],
    [34.71021453089, 135.36413625104],
    [34.71021138902, 135.36415026513],
    [34.71020964354, 135.36416158965],
    [34.71020836352, 135.36417786864],
    [34.71020929444, 135.36419683721],
    [34.71021336723, 135.36421637201],
    [34.71022058189, 135.36423562369],
    [34.71022861111, 135.36425430915],
    [34.71023943309, 135.36427356083],
    [34.71025037144, 135.3642957852],
    [34.71025874975, 135.36431942513],
    [34.71026224071, 135.36433980927],
    [34.71026386983, 135.36435991029],
    [34.71026375346, 135.36438510735],
    [34.71026340436, 135.36440690705],
    [34.71026421892, 135.36442644184],
    [34.71026945536, 135.36444654286],
    [34.71027550636, 135.36446437898],
    [34.71028446661, 135.36447711892],
    [34.71029540496, 135.36448816033],
    [34.71030541238, 135.36449721994],
    [34.71031867802, 135.3645028822],
    [34.71033078001, 135.36450401466],
    [34.71034474385, 135.36449976796],
    [34.71035568218, 135.36449042523],
    [34.71036243137, 135.36447740204],
    [34.71036568959, 135.36445899969],
    [34.71036429321, 135.36444059735],
    [34.71035544945, 135.36442361057],
    [34.71034427839, 135.36441002115],
    [34.71032682359, 135.36439133569],
    [34.71030471418, 135.3643698191],
    [34.71027771742, 135.36433980913],
    [34.71026887348, 135.36432876793],
    [34.71026002971, 135.36431680641],
    [34.71025048775, 135.3643035001],
    [34.71024234234, 135.36429111369],
    [34.71023489484, 135.36428205422],
    [34.71022744745, 135.36426959725],
];

const station = [
    [34.2699650532, 132.91413155846],
    [34.27526320212, 132.92006981161],
    [34.27978789593, 132.92390092412],
];

const station_point = [0, 225, 361];

const station_name = [
    "白水港",
    "古江老人集会所",
    "垂水港",
];

const stop_pos = [34.27136480367, 132.91617418163];

export {
    route,
    station,
    station_point,
    station_name,
    stop_pos
}